module.exports = __webpack_public_path__ + "images/8167598c2a70335f9d495f30fb5ffebe-homestay.png";